import Vue from 'vue'
import VueRouter from 'vue-router'
import cokeRouter from '@/router/coke'
import coalRouter from '@/router/coal'
import powerCoalRouter from '@/router/powerCoal'
import steelRouter from '@/router/steel'
import ironstoneRouter from '@/router/ironstone'
import macroscopicRouter from "@/router/macroscopic";
import methanolRouter from "@/router/methanol";
import oilBenzeneRouter from "@/router/oilBenzene";
import cokeBenzeneRouter from '@/router/cokeBenzene'
import caprolactamRouter from '@/router/caprolactam'
import dataCenter from '@/router/dataCenter'
import adipicRouter from '@/router/adipic'
import styreneRouter from '@/router/styrene'
import zetarRouter from '@/router/zetar'
import anhydrideRouter from '@/router/anhydride'
import asphaltRouter from '@/router/asphalt.js'
import needleRouter from '@/router/needle.js'
import petroleumRouter from '@/router/petroleum.js'
import hydrogenRouter from '@/router/hydrogen.js'
import otherRouter from '@/router/other.js'

Vue.use(VueRouter)

const routerData = [
    cokeRouter,
    coalRouter,
    powerCoalRouter,
    steelRouter,
    ironstoneRouter,
    macroscopicRouter,
    methanolRouter,
    oilBenzeneRouter,
    cokeBenzeneRouter,
    dataCenter,
    caprolactamRouter,
    adipicRouter,
    styreneRouter,
    zetarRouter,
    anhydrideRouter,
    asphaltRouter,
    petroleumRouter,
    hydrogenRouter,
    needleRouter,
    otherRouter
]
let baseRoutes = [
    {
        path: '/index',
        name: '首页',
        component: () => import('@/views/homePage/index')
    },
    {
        path: '/twoPage/file',
        name: 'pdf展示页面',
        component: () => import('@/views/file'),
    },
]
routerData.forEach(item => {
    baseRoutes = baseRoutes.concat(item);
});
const routes = [
    {
        path: '/login',
        name: '登录',
        component: () => import('@/views/login'),
    },
    {
        path: '/transfer',
        name: '中转站',
        component: () => import('@/views/transfer'),
    },
    {
        path: '/',
        redirect: 'index',
        name: '首页',
        component: () => import('@/views/Home.vue'),
        children: baseRoutes
    },
    {
        path: '/authorization',
        name: '企业微信单点登录',
        component: () => import('@/views/authorization'),
    }
]


const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})
//获取原型对象上的push函数
const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
export default router
